import { inject, Injectable, DOCUMENT } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SchemaMarkupService {
	private readonly document = inject(DOCUMENT);

	addForDestination(model: { titleTag: string; items: { position: number; url: string }[] }): void {
		const schema = {
			'@context': 'https://schema.org',
			'@type': 'ItemList',
			name: model.titleTag,
			itemListElement: model.items.map((item) => ({
				'@type': 'ListItem',
				position: item.position,
				url: item.url,
			})),
		};
		this.addSchemaToHead(JSON.stringify(schema));
	}

	addForHotel(model: {
		hotelName: string;
		description: string;
		url: string;
		addressCountry: string;
		addressLocality: string;
		starRating: number;
		images: string[];
	}): void {
		const schema = {
			'@context': 'https://schema.org',
			'@type': 'Hotel',
			name: model.hotelName,
			description: model.description,
			url: model.url,
			address: {
				'@type': 'PostalAddress',
				addressCountry: model.addressCountry,
				addressLocality: model.addressLocality,
			},
			starRating: {
				'@type': 'Rating',
				ratingValue: model.starRating,
			},
			image: model.images,
			contactPoint: {
				'@type': 'ContactPoint',
				telephone: '+381 11 4144 284',
				contactType: 'Customer Service',
				areaServed: 'RS',
				availableLanguage: ['sr', 'en'],
			},
		};
		this.addSchemaToHead(JSON.stringify(schema));
	}

	private addSchemaToHead(schemaStr: string): void {
		this.removeExistingSchema();
		const script = this.document.createElement('script');
		script.type = 'application/ld+json';
		script.text = schemaStr;
		this.document.head.appendChild(script);
	}

	private removeExistingSchema(): void {
		const existingScripts = this.document.querySelectorAll('script[type="application/ld+json"]');
		existingScripts.forEach((script) => {
			script.remove();
		});
	}
}
